const MESSAGES = {
  ALERT_TYPES: {
    SUCCESS: "success",
    ERROR: "danger",
  },
  STORAGE_KEYS: {
    INTRO_MESSAGE: "@tri_intro_message",
  },
  MENU_ITEMS_ALERTS: {
    CREATE_ALERT: "Menu item created successfully.",
    EDIT_ALERT: "Menu item edited successfully.",
    DELETE_ALERT: "Menu item(s) deleted successfully",
  },
  SETTINGS_ALERTS: {
    CREATE_ALERT: "Setting created successfully.",
    EDIT_ALERT: "Setting edited successfully.",
    DELETE_ALERT: "Setting(s) deleted successfully",
  },
  ROLE_ALERTS: {
    CREATE_ALERT: "Role created successfully.",
    EDIT_ALERT: "Role edited successfully.",
    DELETE_ALERT: "Role(s) deleted successfully",
  },
  USER_ALERTS: {
    CREATE_ALERT: "User created successfully.",
    EDIT_ALERT: "User edited successfully.",
    DELETE_ALERT: "User(s) deleted successfully",
  },
  EMAIL_TEMPLATE_ALERTS: {
    CREATE_ALERT: "Email template created successfully.",
    EDIT_ALERT: "Email template edited successfully.",
    DELETE_ALERT: "Email template(s) deleted successfully",
  },
  BLOCKED_IP_ALERTS: {
    CREATE_ALERT: "Blocked IP created successfully.",
    EDIT_ALERT: "Blocked IP edited successfully.",
    DELETE_ALERT: "Blocked IP(s) deleted successfully",
  },
  SMS_TEMPLATE_ALERTS: {
    CREATE_ALERT: "SMS template created successfully.",
    EDIT_ALERT: "SMS template edited successfully.",
    DELETE_ALERT: "SMS template(s) deleted successfully",
  },
  MODULES_ALERTS: {
    CREATE_ALERT: "Module created successfully.",
    EDIT_ALERT: "Module edited successfully.",
    DELETE_ALERT: "Module(s) deleted successfully",
  },
  USER_LOG_ALERTS: {
    DELETE_ALERT: "User Log(s) deleted successfully",
  },
  SENT_SMS_ALERTS: {
    DELETE_ALERT: "Sent SmS(s) deleted successfully",
  },
  SENT_EMAIL_ALERTS: {
    DELETE_ALERT: "Sent Email(s) deleted successfully",
  },
  NOTIFICATION_ALERTS: {
    CREATE_ALERT: "Notification created successfully.",
    EDIT_ALERT: "Notification edited successfully.",
    DELETE_ALERT: "Notification(s) deleted successfully",
  },
  DATABASE_BACKUP_ALERTS: {
    CREATE_ALERT:
      "Database backup initiated, may take couple of minutes to complete.",
    EDIT_ALERT: "Database Backup edited successfully.",
    DELETE_ALERT: "Database Backup(s) deleted successfully",
  },

  BUG_ALERTS: {
    CREATE_ALERT: "Bug created successfully.",
    EDIT_ALERT: "Bug edited successfully.",
    DELETE_ALERT: "Bug(s) deleted successfully",
  },

  VERSION_ALERTS: {
    CREATE_ALERT: "Version created successfully.",
    EDIT_ALERT: "Version edited successfully.",
    DELETE_ALERT: "Version(s) deleted successfully",
  },

  CATEGORY_ALERTS: {
    CREATE_ALERT: "Category created successfully.",
    EDIT_ALERT: "Category edited successfully.",
    DELETE_ALERT: "Category(s) deleted successfully",
  },

  ITEM_ALERTS: {
    CREATE_ALERT: "Inventory Item created successfully.",
    EDIT_ALERT: "Inventory Item edited successfully.",
    DELETE_ALERT: "Inventory Item(s) deleted successfully",
  },
  CUSTOMER_ALERTS: {
    CREATE_ALERT: "Customer created successfully.",
    EDIT_ALERT: "Customer edited successfully.",
    DELETE_ALERT: "Customer(s) deleted successfully",
  },

  PROMOCODE_ALERTS: {
    CREATE_ALERT: "Promo Code created successfully.",
    EDIT_ALERT: "Promo Code edited successfully.",
    DELETE_ALERT: "Promo Code(s) deleted successfully",
  },

  PAGES_ALERTS: {
    CREATE_ALERT: "Page created successfully.",
    EDIT_ALERT: "Page edited successfully.",
    DELETE_ALERT: "Page(s) deleted successfully",
  },
  ORDER_ALERTS: {
    CREATE_ALERT: "Order created successfully.",
    EDIT_ALERT: "Order edited successfully.",
    DELETE_ALERT: "Order(s) deleted successfully",
  },
  PRODUCTS_ALERTS: {
    CREATE_ALERT: "Product created successfully.",
    EDIT_ALERT: "Product edited successfully.",
    DELETE_ALERT: "Product(s) deleted successfully",
  },

  MANUFACTURER_ALERTS: {
    CREATE_ALERT: "Manufacturer created successfully.",
    EDIT_ALERT: "Manufacturer edited successfully.",
    DELETE_ALERT: "Manufacturer(s) deleted successfully",
  },

  BANNER_ALERTS: {
    CREATE_ALERT: "Banner created successfully.",
    EDIT_ALERT: "Banner edited successfully.",
    DELETE_ALERT: "Banner(s) deleted successfully",
  },

  SITE_SETTINGS_ALERTS: {
    CREATE_ALERT: "Site Setting created successfully.",
    EDIT_ALERT: "Site Setting edited successfully.",
    DELETE_ALERT: "Site Setting(s) deleted successfully",
  },

  FILE_UPLOAD_ALERT: {
    FILE_UPLOAD_ALERT: "File uploaded successfully",
  },

  PROFILE_ALERTS: {
    EDIT_ALERT: "Profile edited successfully.",
  },
  BUG_COMMENTS_ALERTS: {
    CREATE_ALERT: "Comment created successfully.",
  },
};

export default MESSAGES;
